import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Tooltip,
} from '@mui/material';

export type DetectionLabelMode = 'off' | 'false_positive' | 'missed_detection';

type Props = {
  mode: DetectionLabelMode;
  onChange: (mode: DetectionLabelMode) => void;
};

/** 라벨링 모드 — 「라벨링」 버튼으로 팝업 개·폐 */
const DetectionLabelToolbar: React.FC<Props> = ({ mode, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="info"
        onClick={() => setOpen(true)}
        sx={{ fontSize: '0.75rem', px: 1.2, py: 0.25, minWidth: 'auto', height: 30 }}
      >
        라벨링
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
        // 시설 전체화면 오버레이(zIndex 1800)보다 위 — 안 보이면 모드 전환 불가
        sx={{ zIndex: 2100 }}
      >
        <DialogTitle>라벨링</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: 1 }}>
            <ToggleButtonGroup
              size="small"
              exclusive
              value={mode}
              onChange={(_, v) => v && onChange(v as DetectionLabelMode)}
            >
              <ToggleButton value="off">끔</ToggleButton>
              <ToggleButton value="false_positive">
                <Tooltip title="잘못 잡힌 감지 박스를 클릭하면 오검출로 저장">
                  <span>오검출</span>
                </Tooltip>
              </ToggleButton>
              <ToggleButton value="missed_detection">
                <Tooltip title="영상 위를 드래그해 미검출 영역 저장">
                  <span>미검출</span>
                </Tooltip>
              </ToggleButton>
            </ToggleButtonGroup>
            {mode === 'false_positive' && (
              <Typography variant="caption" color="warning.main">
                잘못 잡힌 사람 박스 클릭 → 오검출 저장 (그 위치는 사람이 아님). 라벨링
                중에는 CCTV 순환 보기가 열리지 않음.
              </Typography>
            )}
            {mode === 'missed_detection' && (
              <Typography variant="caption" color="info.main">
                사람은 보이는데 검출이 안 된 영역을 드래그 → 미검출 저장 (사람인데 놓침).
                사고·이벤트 처리와는 무관. 라벨링 중에는 CCTV 순환 보기가 열리지 않음.
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>닫기</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DetectionLabelToolbar;
